<ng-container *ngIf="(loading$ | async); else normal">
    <i class="fa-solid fa-loader fa-spin"></i> {{'lbl_guardando' | translate : listTraduction.lbl }}	
</ng-container>
<ng-template #normal>
    <ng-container *ngTemplateOutlet="iconNormal" />
</ng-template>
